/**
 * Fullscreen page spinner / loader.
 */
export default function PageLoader(props) {
    return (
        <div className="loading-overlay" style={{ display: props.show ? "inline-flex" : "none" }}>
            {props.imageSrc && <img className="loading-image" src={props.imageSrc} alt="loading icon"/>}
            <div className="loading-spinner"></div>
        </div>
    );
}
